import Vue from 'vue'

export default {
  withdrawAction(data) {
    return Vue.axios.post('/api/v1/bo/me/transactions/withdraw', data).then((response) => {
      return response.data
    })
  },
  bitcoinRateAction() {
    return Vue.axios.get('/api/v1/bo/paymentoptions/bitcoin-adjustment/withdraw').then((response) => {
      return response.data
    })
  },
  fetchCustomerPaymentOptions(params) {
    return Vue.axios.get(`/api/v1/customer-payment-option/${params.customerId}/fields`, { params }).then(response => response.data)
  },
  fetchAdjustedBitcoinExchangeRates() {
    return Vue.axios.get(`api/v1/payment-option/rates/BITCOIN/EUR`).then(response => response.data)
  }
}